export default function extractErrorInfo(error: unknown): {
  title: string;
  subHeader: string;
  message: string;
} {
  const defaultTitle = "Error";
  const defaultErrorMessage = "Please try again later.";
  const defaultSubHeader = "An error occurred while retrieving the data.";
  if (typeof error === "object" && error !== null && "error" in error) {
    const nestedError = error.error;
    if (typeof nestedError === "object" && nestedError !== null) {
      return {
        title:
          "statusCode" in nestedError && typeof nestedError.statusCode === "number"
            ? String(nestedError.statusCode)
            : defaultTitle,
        message:
          "message" in nestedError && typeof nestedError.message === "string"
            ? nestedError.message
            : defaultErrorMessage,
        subHeader:
          "error" in nestedError && typeof nestedError.error === "string" ? nestedError.error : defaultSubHeader,
      };
    }
  }
  return {
    title: defaultTitle,
    message: defaultErrorMessage,
    subHeader: defaultSubHeader,
  };
}
